import DataGrid, { Column, Summary, TotalItem } from 'devextreme-react/cjs/data-grid'
import React from 'react'

interface CustomerDataModalProp {
    customerData: any[]
}

const CustomerDataModal: React.FC<CustomerDataModalProp> = ({ customerData }) => {
    return (
        <>
            <DataGrid
                dataSource={customerData}
                keyExpr="id"
                showRowLines
                showBorders
                remoteOperations={false}
                allowColumnResizing
                columnAutoWidth
                wordWrapEnabled
            >
                <Summary>
                    <TotalItem
                    // column="sellingPrice" summaryType="sum" displayFormat="Total: {0}" valueFormat="#,##0.00"
                    />
                </Summary>
                <Column dataField="firstName" caption="First Name" />
                <Column dataField="lastName" caption="Last Name" />
                <Column dataField="email" caption="Email" />
                <Column dataField="mobileNo" caption="Mobile No." />
                {/* <Column dataField="storeId" caption="Store ID" dataType="number" /> */}
            </DataGrid>
        </>
    )
}

export default CustomerDataModal
